<dialog-header [dialogRef]="dialogRef" [headerKey]="data.failureDescription ? 'FAILURE_EDIT' : 'FAILURE_ADD'"></dialog-header>
<div mat-dialog-content [ngSwitch]="data.taskVersion">

  <failure-form-v1
    *ngSwitchCase="1"
    [data]="data"
    (closeDialogEvent)="close($event)"
    (deleteDefectEvent)="deleteDefectEvent.emit()"
  />

  <failure-form-v2
    *ngSwitchCase="2"
    [data]="data"
    (closeDialogEvent)="close($event)"
    (deleteDefectEvent)="deleteDefectEvent.emit()"
  />

  <failure-form-v3
    *ngSwitchCase="3"
    [data]="data"
    (closeDialogEvent)="close($event)"
    (deleteDefectEvent)="deleteDefectEvent.emit()"
  />
</div>
